export const Participant = {
    One: {
        defaultIndex: 0,
        role: "Home",
        score: "homeScore",
        swappedDefaultIndex: 1,
        swappedRole: "Away",
        swappedScore: "awayScore"
    },
    Two: {
        defaultIndex: 1,
        role: "Away",
        score: "awayScore",
        swappedDefaultIndex: 0,
        swappedRole: "Home",
        swappedScore: "homeScore"
    }
};
export const AggregatedScoresMap = {
    cornersTeam1: "corners",
    cornersTeam2: "corners",
    penaltiesTeam1: "penalties",
    penaltiesTeam2: "penalties",
    redCardsTeam1: "redCards",
    redCardsTeam2: "redCards",
    yellowCardsTeam1: "yellowCards",
    yellowCardsTeam2: "yellowCards"
};
export const IncidentTypes = [
    "Goal",
    "Corner",
    "Penalty",
    "YellowCard",
    "RedCard"
];
//# sourceMappingURL=Constants.js.map